import { Marker, Popup } from 'react-leaflet';
import { LatLngTuple, DivIcon } from 'leaflet';
import { HQ_COLOR } from '../utils/mapColors';

/**
 * Create HQ marker icon
 */
function createHQIcon(color: string = HQ_COLOR): DivIcon {
  return new DivIcon({
    className: 'hq-marker',
    html: `<div style="display:flex;align-items:center;justify-content:center;width:28px;height:28px;background:${color};color:#fff;border-radius:50%;font-size:10px;font-weight:700;box-shadow:0 2px 4px rgba(0,0,0,0.3);border:2px solid #fff;">HQ</div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}

interface HQMarkerProps {
  /**
   * HQ position [lat, lng]
   */
  position: LatLngTuple;
  /**
   * HQ address for popup
   */
  address: string;
  /**
   * Custom color for HQ marker
   * @default HQ_COLOR (amber-500)
   */
  color?: string;
  /**
   * Custom label for the marker
   * @default 'HQ'
   */
  label?: string;
}

/**
 * Headquarters marker component
 * Displays a special orange marker for company HQ location
 */
export function HQMarker({
  position,
  address,
  color = HQ_COLOR,
  label = 'HQ',
}: HQMarkerProps) {
  const icon = createHQIcon(color);

  return (
    <Marker position={position} icon={icon}>
      <Popup>
        <strong>{label}</strong>
        <br />
        {address}
      </Popup>
    </Marker>
  );
}
